var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.edit)?_c('StipendiatSborStories',{attrs:{"edit":_vm.edit},on:{"edit-story":_vm.componentSwitch}}):_c('StipendiatSborStory',{attrs:{"edit":_vm.edit},on:{"edit-story":_vm.componentSwitch}})}
var staticRenderFns = []

export { render, staticRenderFns }